import { render, staticRenderFns } from "./distributorManagement.vue?vue&type=template&id=655118e6"
import script from "./distributorManagement.vue?vue&type=script&lang=js"
export * from "./distributorManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports